import { Component, input, OnInit, AfterViewInit, ViewChild, ElementRef, Renderer2 } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { InterestedHost, InterestedHostClient, InterestedHostDetail, User } from '../Services/WOWApi.Service';
import { CommonServices } from '../Common/CommonServices';
import { CustomServiceService } from '../Services/custom-service.service';
import { Subscription } from 'rxjs';
import { CommonService } from '../Services/common.service';

@Component({
  selector: 'app-host-sign-up',
  templateUrl: './host-sign-up.component.html',
  styleUrls: ['./host-sign-up.component.css'],
  standalone: false
})
export class HostSignUpComponent implements OnInit, AfterViewInit {
  businessImageValidate: boolean = false;
  response: string = null;
  applicationSubmitted = false;
  submittedRequestId: string | null = null;
  applicantFirstName = '';
  applicantLastName = '';
  businessImage: any;
  businessImageFile: any;
  taxSsnValidate: boolean = false;
  fflImage: any;
  fflImageFile: any;
  fflImageValidate: boolean = false;
  MAX_SIZE: number = 1048576 * 5;
  yearsInBussinessOption: any = [];
  onlineRatingCompanyOptions: any = [];
  noOfSubscriber: any = [];
  itemPlanToHost: any = [];
  interestedHost: InterestedHost;
  showSpinner: boolean = false;
  theFile: any[] = [];
  personalDetails!: UntypedFormGroup;
  businessDetails!: UntypedFormGroup;
  marketDetails!: UntypedFormGroup;
  consentDetails!: UntypedFormGroup;
  personal_step = false;
  business_step = false;
  market_step = false;
  consent_step = false;
  step = 1;
  loggedUser: User;
  isMobileView = false;
  subscription: Subscription;
  showPhotoPreview = false;
  activePolicyModal: 'payment' | 'shipping' | 'dispute' | 'hosting' | 'privacy' | null = null;
  constructor(private formBuilder: UntypedFormBuilder, private commonServices: CommonServices,
    private interestedHostClient: InterestedHostClient, private customService: CustomServiceService,
    private commonService: CommonService, private el: ElementRef, private renderer: Renderer2) { }

  ngOnInit(): void {
    this.subscription = this.commonService.isMobileView.subscribe(res => this.isMobileView = res);
    this.loggedUser = this.customService.GetLoggedInUser();
    console.log(this.loggedUser);
    this.GetForm();
    this.getYearsInBusinessOption();
    this.getOnlineRatingCompanyOption();
    this.getNumOfSubscriberOption();
    this.getItemToSell();
    this.listenOnlineSellerDDChanges();
    // ensure headers reflect initial state
    setTimeout(() => this.updateStepHeaderErrors(), 0);

  }

  ngAfterViewInit(): void {
    // ensure headers updated once view initialized
    setTimeout(() => this.updateStepHeaderErrors(), 0);
  }

  GetForm() {
    this.personalDetails = this.formBuilder.group({
      FirstName: [this.loggedUser.firstName, Validators.required],
      LastName: [this.loggedUser.lastName, Validators.required],
      CellNumber: ['', [Validators.required, Validators.minLength(10), Validators.maxLength(10)]],
      Email: [this.loggedUser.emailId, [Validators.required, Validators.email]],
      SSN: [''],
      TaxId: [''],
      PrefferedRooName: ['',Validators.required],
      OnlineSeller: [true],
      ExplanationText: [''],
      HasBusiness: ['']
    });

    this.businessDetails = this.formBuilder.group({
      BusinessName: [''],
      BusinessDBA: [''],
      BusinessAddress: [''],
      BusinessPhone: ['', [Validators.minLength(10), Validators.maxLength(10)]],
      companyName: ['']
    });

    this.marketDetails = this.formBuilder.group({
      CustomerBase: [''],
      YearsOfBusiness: [''],
      OnlineRatingCompany: [''],
      OnlineRatingScore: [''],
      PrimaryItemOfSale: [''],
      SecondryItemOfSale: [''],
      NumberOfSubscriber: ['']
      // TaxId moved to personalDetails
    });

    this.consentDetails = this.formBuilder.group({
      ContactConsent: [false, [Validators.required]],
      HostingConsent: [false, [Validators.required]],
      PaymentPolicyConsent: [false, [Validators.required]],
      ResolutionDisputePolicyConsent: [false, [Validators.required]],
      ShippingPolicyConsent: [false, [Validators.required]],
      PrivacyPolicyConsent: [false, [Validators.required]]
    });

    // clear tax/ssn validation when user types
    this.personalDetails.controls['TaxId'].valueChanges.subscribe(() => {
      if (this.taxSsnValidate) {
        this.taxSsnValidate = false;
        this.updateStepHeaderErrors();
      }
    });
    this.personalDetails.controls['SSN'].valueChanges.subscribe(() => {
      if (this.taxSsnValidate) {
        this.taxSsnValidate = false;
        this.updateStepHeaderErrors();
      }
    });
  }

  // mark steps visited when user navigates via stepper headers
  onStepSelectionChange(event: any) {
    const index = event.selectedIndex;
    if (index >= 0 && this.personalDetails.valid) {
      this.personal_step = true;
    }
    if (index >= 1 && this.personalDetails.valid && this.personal_step) {
      this.business_step = true;
    }
    if (index >= 2 && this.personalDetails.valid && this.businessDetails.valid && this.business_step) {
      this.market_step = true;
    }
    if (index >= 3 && this.personalDetails.valid && this.businessDetails.valid && this.marketDetails.valid && this.market_step) {
      this.consent_step = true;
    }
    console.log(this.personal_step, this.business_step, this.market_step, this.consent_step);
    
    if (!this.personal_step && !this.business_step && !this.market_step && !this.consent_step) {
      return
    }
    console.log(event);
    this.updateStepHeaderErrors();
  }
  //#endregion

  //#region select options
  getYearsInBusinessOption() {
    this.interestedHostClient.getYearsIntoBusiness().subscribe({
      next: response => this.yearsInBussinessOption = response,
      error: err => this.logHostError('getYearsIntoBusiness failed', err, 'Could not load years-in-business options. Please refresh and try again.')
    });
  }
  getOnlineRatingCompanyOption() {
    this.interestedHostClient.getOnlineRatingCompany().subscribe({
      next: response => this.onlineRatingCompanyOptions = response,
      error: err => this.logHostError('getOnlineRatingCompany failed', err, 'Could not load rating companies. Please refresh and try again.')
    });
  }

  getNumOfSubscriberOption() {
    this.interestedHostClient.getSubscriberRange().subscribe({
      next: response => this.noOfSubscriber = response,
      error: err => this.logHostError('getSubscriberRange failed', err, 'Could not load subscriber ranges. Please refresh and try again.')
    });
  }
  getItemToSell() {
    this.interestedHostClient.getItemsToSell().subscribe({
      next: response => this.itemPlanToHost = response,
      error: err => this.logHostError('getItemsToSell failed', err, 'Could not load items to sell. Please refresh and try again.')
    });
  }

  //#endregion

  //#region getFormValue
  get getFirstName() {
    return this.personalDetails.controls["FirstName"];
  }
  get getLastName() {
    return this.personalDetails.controls["LastName"];
  }
  get getCellNumber() {
    return this.personalDetails.controls["CellNumber"];
  }
  get getEmail() {
    return this.personalDetails.controls["Email"];
  }
  get getOnlineSeller() {
    return this.personalDetails.controls["OnlineSeller"];
  }
  get getHasBusiness() {
    return true ; //this.personalDetails.controls["HasBusiness"];
  }
  get getExplanationText() {
    return this.personalDetails.controls["ExplanationText"];
  }
  get getBusinessName() {
    return this.businessDetails.controls["BusinessName"];
  }
  get getBusinessDBA() {
    return this.businessDetails.controls["BusinessDBA"];
  }
  get getBusinessAddress() {
    return this.businessDetails.controls["BusinessAddress"];
  }
  get getBusinessPhone() {
    return this.businessDetails.controls["BusinessPhone"];
  }
  get getCompanyName() {
    return this.businessDetails.controls["companyName"];
  }
  get getCustomerBase() {
    return this.marketDetails.controls["CustomerBase"];
  }
  get getYearsOfBusiness() {
    return this.marketDetails.controls["YearsOfBusiness"];
  }
  get getOnlineRatingCompany() {
    return this.marketDetails.controls["OnlineRatingCompany"];
  }
  get getOnlineRatingScore() {
    return this.marketDetails.controls["OnlineRatingScore"];
  }
  get getPrimaryItemOfSale() {
    return this.marketDetails.controls["PrimaryItemOfSale"];
  }
  get getSecondryItemOfSale() {
    return this.marketDetails.controls["SecondryItemOfSale"];
  }
  get getNumberOfSubscriber() {
    return this.marketDetails.controls["NumberOfSubscriber"];
  }
  get getTaxId() {
    return this.personalDetails.controls["TaxId"];
  }
  get getSSN() {
    return this.personalDetails.controls["SSN"];
  }
  get getContactConsent() {
    return this.consentDetails.controls["ContactConsent"].value;
  }
  get getHostingConsent() {
    return this.consentDetails.controls["HostingConsent"].value;
  }
  get getPaymentPolicyConsent() {
    return this.consentDetails.controls["PaymentPolicyConsent"].value;
  }
  get getResolutionDisputePolicyConsent() {
    return this.consentDetails.controls["ResolutionDisputePolicyConsent"].value;
  }
  get getShippingPolicyConsent() {
    return this.consentDetails.controls["ShippingPolicyConsent"].value;
  }
  get getPrivacyPolicyConsent() {
    return this.consentDetails.controls["PrivacyPolicyConsent"].value;
  }
  get getPrefferedRooName() {
    return this.personalDetails.controls["PrefferedRooName"];
  }
  //#endregion

  EnableFFLImage() {
    const primaryName = this.getPrimaryItemOfSale.value?.name;
    const secondaryName = this.getSecondryItemOfSale.value?.name;
    if (!primaryName && !secondaryName) {
      return false;
    }
    if (primaryName == "Class 2 Fire Arms" || secondaryName == "Class 2 Fire Arms") {
      return true;
    }
    return false;

  }

  //#region save
  getSignToHostObject() {
    var interestedHost = new InterestedHost();

    interestedHost.firstName = this.getFirstName.value;
    interestedHost.lastName = this.getLastName.value;
    interestedHost.phone = this.getCellNumber.value;
    interestedHost.email = this.getEmail.value;
    interestedHost.isCurrentOnlineSeller = this.getOnlineSeller.value;
    interestedHost.whyStrongSeller = this.getExplanationText.value;
    interestedHost.submittedBy = this.loggedUser.id;
    interestedHost.consent = this.getContactConsent;

    interestedHost.interestedHostDetails = [];
    let interestedHostDetails = new InterestedHostDetail();
    interestedHostDetails.businessName = this.getBusinessName.value;
    interestedHostDetails.businessAddress = this.getBusinessAddress.value;
    interestedHostDetails.businessDba = this.getBusinessDBA.value;
    interestedHostDetails.businessPhoneNumber = this.getBusinessPhone.value;
    interestedHostDetails.companyName = this.getCompanyName.value;
    interestedHostDetails.yearsInBusinessId = this.getYearsOfBusiness.value?.id;
    interestedHostDetails.onlineRatingCompanyId = this.getOnlineRatingCompany.value?.id;
    interestedHostDetails.onlineRatingScore = this.getOnlineRatingScore.value;
    interestedHostDetails.primaryItemsId = this.getPrimaryItemOfSale.value?.id;
    interestedHostDetails.secondayItemId = this.getSecondryItemOfSale.value?.id;
    interestedHostDetails.howManySubscribersId = this.getNumberOfSubscriber.value?.id;
    interestedHostDetails.taxId = this.getTaxId.value;
    interestedHostDetails.ssn = this.getSSN.value;
    interestedHostDetails.termAndCondition = this.getHostingConsent;
    interestedHostDetails.resolutionAndDisputePolicy = this.getResolutionDisputePolicyConsent;
    interestedHostDetails.paymentPolicy = this.getPaymentPolicyConsent;
    interestedHostDetails.shippingPolicy = this.getShippingPolicyConsent;
    interestedHostDetails.prefferedRoomName = this.getPrefferedRooName.value; 
    interestedHostDetails.privacyPolicy = this.getPrivacyPolicyConsent;
    interestedHost.interestedHostDetails[0] = interestedHostDetails;


    return interestedHost;
  }
  preview(event, type) {

    if (!event.target.files)
      return;



    var mimeType = event.target.files[0].type;

    if (mimeType.match(/image\/*/) == null) {
      this.logHostError('rejected non-image upload', { name: event.target.files[0].name, type: mimeType }, 'Only images are supported.');
      return;
    }


    // Don't allow file sizes over 1MB
    if (event.target.files[0].size > this.MAX_SIZE) {
      this.logHostError('rejected oversized upload', { name: event.target.files[0].name, size: event.target.files[0].size }, event.target.files[0].name + " is too large to upload.");
      return false;
    }

    for (var i = 0; i < event.target.files.length; i++) {

      var element = event.target.files[i];
      if (type == "BusinessImage") {
        this.businessImageFile = event.target.files[i];
      }
      else {
        this.fflImageFile = event.target.files[i];
      }
      var imagePath = this.getBase64String(element, type)
    }
  }

  getBase64String(url, type) {
    var reader = new FileReader();
    reader.readAsDataURL(url);
    reader.onload = (event) => {
      if (type == "BusinessImage") {
        this.businessImageValidate = false;
        this.businessImage = {};
        this.businessImage.image = event.target.result;
        // update header errors now that image exists
        setTimeout(() => this.updateStepHeaderErrors(), 0);
      }
      else {
        this.fflImageValidate = false;
        this.fflImage = {};
        this.fflImage.image = event.target.result;
      }
    }
  }

  // update mat-step-header DOM classes based on validation flags
  updateStepHeaderErrors() {
    try {
      const headers = this.el.nativeElement.querySelectorAll('mat-horizontal-stepper .mat-step-header');
      if (!headers || headers.length === 0) return;
      // personal
      const personalError = (this.personalDetails?.invalid && this.personal_step) || this.businessImageValidate;
      this.toggleHeaderClass(headers[0], 'custom-step-error', personalError);
      // business
      const businessError = (this.businessDetails?.invalid && this.business_step);
      if (headers[1]) this.toggleHeaderClass(headers[1], 'custom-step-error', businessError);
      // market
      const marketError = (this.marketDetails?.invalid && this.market_step);
      if (headers[2]) this.toggleHeaderClass(headers[2], 'custom-step-error', marketError);
      // consent
      const consentError = (this.consentDetails?.invalid && this.consent_step);
      if (headers[3]) this.toggleHeaderClass(headers[3], 'custom-step-error', consentError);
    } catch (e) {
      // no-op
    }
  }

  toggleHeaderClass(el: any, className: string, add: boolean) {
    if (!el) return;
    if (add) this.renderer.addClass(el, className);
    else this.renderer.removeClass(el, className);
  }
  SaveSignToHost() {
    const firstName = this.personalDetails.controls.FirstName.value;
    const lastName = this.personalDetails.controls.LastName.value
    const hasLettersFirstName = /[a-zA-Z]/.test(firstName);
    const hasLettersLastName = /[a-zA-Z]/.test(lastName);
    if (!hasLettersFirstName) {
      this.commonServices.showMessage('error', 'Charactor is mandatory in First Name', 5);
      return false;
    }
    if (!hasLettersLastName) {
      this.commonServices.showMessage('error', 'Charactor is mandatory in Last Name', 5);
      return false;
    }
    if (this.consentDetails.controls.ContactConsent.invalid) {
      this.commonServices.showMessage('error', 'Please accept the contact consent', 5);
      this.consent_step = true;
      this.updateStepHeaderErrors();
      return false;
    }
    if (this.consentDetails.controls.HostingConsent.value === false) {
      this.commonServices.showMessage('error', 'Please accept the hosting consent', 5);
      this.consent_step = true;
      this.updateStepHeaderErrors();
      return false;
    }
    if (this.consentDetails.controls.PaymentPolicyConsent.value === false) {
      this.commonServices.showMessage('error', 'Please accept the payment policy consent', 5);
      this.consent_step = true;
      this.updateStepHeaderErrors();
      return false;
    }
    if (this.consentDetails.controls.ResolutionDisputePolicyConsent.value === false) {
      this.commonServices.showMessage('error', 'Please accept the resolution dispute consent', 5);
      this.consent_step = true;
      this.updateStepHeaderErrors();
      return false;
    }
    if (this.consentDetails.controls.ShippingPolicyConsent.value === false) {
      this.commonServices.showMessage('error', 'Please accept the shipping policy consent', 5);
      this.consent_step = true;
      this.updateStepHeaderErrors();
      return false;
    }
    if (this.consentDetails.controls.PrivacyPolicyConsent.value === false) {
      this.commonServices.showMessage('error', 'Please accept the privacy policy consent', 5);
      this.consent_step = true;
      this.updateStepHeaderErrors();
      return false;
    }

    // Require either TaxId or SSN
    if ((!this.getTaxId.value || this.getTaxId.value === '') && (!this.getSSN.value || this.getSSN.value === '')) {
      this.taxSsnValidate = true;
      this.personal_step = true;
      this.updateStepHeaderErrors();
      this.commonServices.showMessage('error', 'Please provide either Tax ID or SSN', 5);
      return false;
    }

    if (this.personalDetails.valid && this.businessDetails.valid && this.marketDetails.valid && this.consentDetails.valid) {
      if (this.businessImage == undefined || this.businessImage == null) {
        this.businessImageValidate = true;
        return false;
      }
      if (this.getPrimaryItemOfSale.value?.name == "Class 2 Fire Arms" || this.getSecondryItemOfSale.value?.name == "Class 2 Fire Arms") {
        if (this.fflImage == undefined || this.fflImage == null) {
          this.fflImageValidate = true;
          return false;
        }
      }
      this.showSpinner = true;
      var saveobj = this.getSignToHostObject();
      this.interestedHostClient.createInterestedHost(saveobj).subscribe({
        next: response => {
          this.customService.UploadBusinessImage(this.businessImageFile, response.id).subscribe({
            next: () => {
              if (this.getPrimaryItemOfSale.value?.name == "Class 2 Fire Arms" || this.getSecondryItemOfSale.value?.name == "Class 2 Fire Arms") {
                this.customService.UploadFFlImage(this.fflImageFile, response.id).subscribe({
                  next: () => this.showSuccess(response.requestId),
                  error: err => {
                    this.showSpinner = false;
                    this.logHostError('UploadFFlImage failed', err, 'Host request saved, but FFL image upload failed. Please try again.');
                  }
                });
              }
              else {
                this.showSuccess(response.requestId);
              }
            },
            error: err => {
              this.showSpinner = false;
              this.logHostError('UploadBusinessImage failed', err, 'Host request saved, but business photo upload failed. Please try again.');
            }
          });
        },
        error: err => {
          this.showSpinner = false;
          this.logHostError('createInterestedHost failed', err, 'We could not submit your host request. Please try again.');
        }
      });
    }
  }

  private logHostError(context: string, error?: unknown, userMessage?: string): void {
    console.error(`[HostSignUp] ${context}`, this.describeError(error), error ?? '');
    if (userMessage) {
      this.commonServices.showMessage('error', userMessage, 8);
    }
  }

  private describeError(error: unknown): string {
    if (!error) {
      return 'unknown error';
    }
    if (typeof error === 'string') {
      return error;
    }
    const anyErr = error as { status?: number; statusText?: string; message?: string; error?: any };
    const body = anyErr?.error;
    const bodyMsg = typeof body === 'string'
      ? body
      : (body?.message || body?.title || body?.detail || '');
    return `status=${anyErr.status ?? 'n/a'} ${anyErr.statusText ?? ''} message=${anyErr.message ?? ''} body=${bodyMsg}`.trim();
  }
  showSuccess(requestId: any) {
    this.applicantFirstName = (this.getFirstName?.value || this.loggedUser?.firstName || '').toString().trim();
    this.applicantLastName = (this.getLastName?.value || this.loggedUser?.lastName || '').toString().trim();
    this.submittedRequestId = requestId;
    this.applicationSubmitted = true;
    this.response = requestId;
    this.personalDetails.reset();
    this.marketDetails.reset();
    this.businessDetails.reset();
    this.consentDetails.reset();
    this.step = 1;
    this.showSpinner = false;
    setTimeout(() => {
      document.querySelector('.host-success')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }, 0);
  }

  get successHeadline(): string {
    return this.applicantFirstName ? `Way to go, ${this.applicantFirstName}!` : 'Way to go!';
  }

  get successBody(): string {
    const fullName = [this.applicantFirstName, this.applicantLastName].filter(Boolean).join(' ');
    if (fullName) {
      return `${fullName}, your host application is in. You're one step closer to going live, filling rooms, and earning from every webinar.`;
    }
    return `Your host application is in. You're one step closer to going live, filling rooms, and earning from every webinar.`;
  }
  //#endregion

  //#region listner
  listenOnlineSellerDDChanges() {
    // Do not force other validators; keep listener for future logic if needed
    this.personalDetails.controls["OnlineSeller"].valueChanges.subscribe(res => {
      // No automatic validator changes: other fields are optional per requirement
    });
  }
  //#endregion

  onlyIntegerOneToTenAllowed(event: KeyboardEvent) {
  const inputElement = event.target as HTMLInputElement;
  const allowedKeys = ['Backspace', 'ArrowLeft', 'ArrowRight', 'Tab', 'Delete'];

  // Allow control keys
  if (allowedKeys.includes(event.key)) return;

  const char = event.key;

  // Disallow non-digit characters and dot
  if (!/^[0-9]$/.test(char)) {
    event.preventDefault();
    this.commonServices.showMessage('error', 'Only digits 1–10 allowed', 2);
    return;
  }

  const currentValue = inputElement.value;
  const selectionStart = inputElement.selectionStart || 0;
  const selectionEnd = inputElement.selectionEnd || 0;

  const proposedValue =
    currentValue.substring(0, selectionStart) +
    char +
    currentValue.substring(selectionEnd);

  // Prevent decimal points
  if (proposedValue.includes('.')) {
    event.preventDefault();
    this.commonServices.showMessage('error', 'Decimals not allowed', 2);
    return;
  }

  // Limit to two digits max (because "10" is valid)
  if (proposedValue.length > 2) {
    event.preventDefault();
    this.commonServices.showMessage('error', 'Max 2 digits', 2);
    return;
  }

  const numericValue = parseInt(proposedValue, 10);
  if (numericValue > 10 || numericValue === 0) {
    event.preventDefault();
    this.commonServices.showMessage('error', 'Enter number between 1 and 10', 2);
  }
}

  openPolicyModal(kind: 'payment' | 'shipping' | 'dispute' | 'hosting' | 'privacy') {
    this.activePolicyModal = kind;
  }

  closePolicyModal() {
    this.activePolicyModal = null;
  }

  get policyModalTitle(): string {
    if (this.activePolicyModal === 'payment') {
      return 'Payment Policy';
    }
    if (this.activePolicyModal === 'shipping') {
      return 'Shipping Policy';
    }
    if (this.activePolicyModal === 'dispute') {
      return 'Resolution and Dispute Policy';
    }
    if (this.activePolicyModal === 'hosting') {
      return 'Hosting Terms and Conditions';
    }
    if (this.activePolicyModal === 'privacy') {
      return 'Privacy Policy';
    }
    return '';
  }

  openPhotoPreview() {
    if (!this.businessImage?.image) {
      return;
    }
    this.showPhotoPreview = true;
  }

  closePhotoPreview() {
    this.showPhotoPreview = false;
  }




}
